import { render } from "./CompaniesServingAreaHeader.vue?vue&type=template&id=97c5f062"
import script from "./CompaniesServingAreaHeader.vue?vue&type=script&lang=js"
export * from "./CompaniesServingAreaHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__